import { checkIfVariantOutOfStock } from '../product/variant-utils';

/**
 * @type {import('../index.d').updateBackInStockDisplay}
 */
export async function updateBackInStockDisplay(moduleContext, product) {
  const { hideOnSpecificCollection, hideOnSpecificTag } = moduleContext.settings.productSettings();

  const hideCollectionIds =
    hideOnSpecificCollection.collectionIds?.map((c) => String(c.value)) || [];

  const isVariantOutOfStock = await checkIfVariantOutOfStock(product);
  const isInSpecificCollection = checkIfInSpecificCollection(product, hideCollectionIds);
  const hasSpecificTag = checkIfHasSpecificTag(
    product,
    hideOnSpecificTag.tags?.length ? hideOnSpecificTag.tags : []
  );

  let shouldShowNotifyButton = false;

  if (isVariantOutOfStock) {
    shouldShowNotifyButton = true;
    if (hideOnSpecificCollection.hide && hideOnSpecificTag.hide) {
      if (isInSpecificCollection || hasSpecificTag) {
        shouldShowNotifyButton = false;
      }
    } else if (hideOnSpecificCollection.hide && !hideOnSpecificTag.hide) {
      if (isInSpecificCollection) {
        shouldShowNotifyButton = false;
      }
    } else if (!hideOnSpecificCollection.hide && hideOnSpecificTag.hide) {
      if (hasSpecificTag) {
        shouldShowNotifyButton = false;
      }
    } else {
      shouldShowNotifyButton = true;
    }
  } else {
    shouldShowNotifyButton = true;
    if (
      (hideOnSpecificCollection.hide && isInSpecificCollection) ||
      (hideOnSpecificTag.hide && hasSpecificTag)
    ) {
      shouldShowNotifyButton = false;
    }
  }

  return {
    showNotifyButton: shouldShowNotifyButton,
  };
}

/**
 * @type {import('../index.d').checkIfInSpecificCollection}
 */
function checkIfInSpecificCollection(product, collectionIds) {
  if (!product || !product.collections) return false;
  const productCollectionIds = product.collections.map((c) => String(c.id));
  return productCollectionIds.some((id) => collectionIds.includes(id));
}

/**
 * @type {import('../index.d').checkIfHasSpecificTag}
 */
function checkIfHasSpecificTag(product, tags) {
  if (!product || !tags) return false;
  const productTags = product.tags || [];
  return tags.some((tag) => productTags.includes(tag));
}
